export const environment = {
  baseUrl: 'https://staging.sso.auth.vettimes.com/api/',
  myAccountBaseUrl: 'https://staging.sso.myaccount.vettimes.com/api/',
  analyticsBaseUrl: 'https://dev.tracking.vettimes.com/api/',
  myJobsUrl: 'https://myjobs.vettimes.com/#/',
  vettimesUrl: 'https://staging.vettimes.com/',
  subDomain: '.vettimes.com',
  googleAnalyticsKey: 'SSO-V3',
  production: false
};
